import React from 'react'
import SidebarTranscript from './SidebarTranscript/SidebarTranscript'
import {SidebarTranscriptsViewProps} from './types'
import {styled} from 'stitches/config'
import {styledGroup} from 'components/Sidebar/styles'
import {useTranslation} from 'react-i18next'

const StyledGroup = styled('ul', styledGroup)

const SidebarTranscriptsView = (props: SidebarTranscriptsViewProps): React.ReactElement => {
    const {
        parentQueueSettings,
        queueTranscripts,
    } = props

    const {t} = useTranslation()

    return (
        <StyledGroup aria-label={t('Transcripts')} nested={true}>
            {
                Object.keys(queueTranscripts).map((audience_id) => (
                    <SidebarTranscript
                        key={audience_id}
                        parentQueueSettings={parentQueueSettings}
                        transcript={queueTranscripts[audience_id]}
                    />
                ))
            }
        </StyledGroup>
    )
}

export default SidebarTranscriptsView
